:host {
  display: contents;
}

/* ---------- Modal part overrides ----------- */

inmar-hc-modal::part(dialog) {
  align-items: flex-start;
  overflow-y: auto;
  padding: var(--spacing-4) 0;
}

inmar-hc-modal::part(content) {
  max-height: none;
  margin: auto;
}

inmar-hc-modal::part(header) {
  padding: 0 var(--spacing-6) var(--spacing-6);
  border-bottom: 1px solid var(--color-gray-300);
}

inmar-hc-modal::part(body) {
  padding: 0;
  overflow: visible;
  flex: none;
}

inmar-hc-modal::part(footer) {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--spacing-6);
  gap: var(--spacing-4);
  border-top: 1px solid var(--color-gray-300);
  margin-left: calc(-1 * var(--spacing-6));
  margin-right: calc(-1 * var(--spacing-6));
  margin-bottom: calc(-1 * var(--spacing-6));
}

/* ---------- Stepper ----------- */

.stepper-container {
  display: flex;
  justify-content: center;
  margin: 0 calc(-1 * var(--spacing-6));
  padding: var(--spacing-6) 0;
  border-bottom: 1px solid var(--color-gray-300);
}

.stepper-container inmar-hc-stepper {
  margin: 0;
}
